export default "/stg-eth.b15378057d0fe5c81a164c4015894588.svg";